export const cancelRequestedRefund = (invoiceObjectId: string) => {
	return {
		method: "PUT",
		url: `${process.env.REACT_APP_ORIGIN}/invoice/requested-refund/${invoiceObjectId}`
	}
}
